import api from "@/Library/api.js";

export default {

    //测试访问接口
    TEST_INDEX(data) {
        return api({ url: "/EsTest/index", method: "post", act: "pro_xlsout", data: data });
    },

    //上传图片信息
    UPLOAD_FILES(data) {
        return api({ url: "/Upload/index", method: "post", act: "", data: data });
    },

    //上传图片文件信息
    UPLOAD_FILES_IMG(data) {
        return api({ url: "/EsFileupload/Upload_File_Img", method: "post", act: "", data: data });
    },

    //上传视频信息
    UPLOAD_FILES_VEDIO(data) {
        return api({ url: "/EsFileupload/Upload_Vedio", method: "post", act: "", data: data });
    },

    //上传pdf信息
    UPLOAD_FILES_PDF(data) {
        return api({ url: "/EsFileupload/Upload_Pdf", method: "post", act: "", data: data });
    },

    //上传vr信息
    UPLOAD_FILES_VR(data) {
        return api({ url: "/EsFileupload/Upload_Vr", method: "post", act: "", data: data });
    },

}